import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { SelectButton } from "primereact/selectbutton";
import { REVISAO } from "../../../../../nova-obra.constants";
import { RevisaoGantt } from "../../../revisao-gantt";
import styles from "../../../../etapa-revisao.module.scss";
import type { LinhaDoTempoViewModel, LinhaTabela, LinhaTempo } from "./types-linha-do-tempo";

export function LinhaDoTempoView({
  visao,
  mudarVisao,
  opcoesVisao,
  ptVisao,
  linhas,
  gantt,
  temGantt,
}: LinhaDoTempoViewModel) {
  return (
    <div className={styles.timeline} data-testid="revisao-linha-do-tempo">
      <div className={styles.timelineTopo}>
        <h4 className={styles.timelineTitulo}>{REVISAO.duracao.linhaDoTempo}</h4>
        <SelectButton
          value={visao}
          options={opcoesVisao}
          onChange={mudarVisao}
          allowEmpty={false}
          aria-label={REVISAO.duracao.alternadorLabel}
          pt={ptVisao}
        />
      </div>

      {linhas.length === 0 ? (
        <p className={styles.campoValor}>{REVISAO.duracao.semPeriodos}</p>
      ) : !temGantt ? (
        <DataTable
          value={linhas}
          dataKey="uid"
          size="small"
          className={styles.timelineTabela}
          tableClassName={styles.timelineTabelaFixa}
          pt={{ wrapper: { className: styles.timelineWrapper } }}
          data-testid="revisao-timeline-tabela"
        >
          <Column header={REVISAO.duracao.colPeriodo} body={(linha: LinhaTempo) => linha.rotulo} />
          <Column
            header={REVISAO.duracao.colInicio}
            headerClassName={styles.colData}
            body={(linha: LinhaTabela) => linha.inicioFormatado}
          />
          <Column
            header={REVISAO.duracao.colFim}
            headerClassName={styles.colData}
            body={(linha: LinhaTabela) => linha.fimFormatado}
          />
          <Column
            header={REVISAO.duracao.colDuracao}
            headerClassName={styles.colDuracao}
            align="right"
            alignHeader="right"
            body={(linha: LinhaTempo) => linha.duracao ?? REVISAO.vazio}
          />
          <Column
            header={REVISAO.duracao.colMeta}
            headerClassName={styles.colMeta}
            align="right"
            alignHeader="right"
            body={(linha: LinhaTempo) => linha.meta ?? REVISAO.vazio}
          />
        </DataTable>
      ) : gantt ? (
        <RevisaoGantt modelo={gantt} />
      ) : (
        <p className={styles.campoValor}>{REVISAO.duracao.semPeriodos}</p>
      )}
    </div>
  );
}
